import React from 'react';
import { useI18n } from '@/lib/i18n';
import { Check } from '@phosphor-icons/react';

const CONSTRUCTION_IMG = 'https://images.unsplash.com/photo-1503387762-592deb58ef4e?auto=format&fit=crop&w=1600&q=80';
const OTHER_IMG = 'https://images.unsplash.com/photo-1553413077-190dd305871c?auto=format&fit=crop&w=1600&q=80';

export default function Services() {
  const { t } = useI18n();
  return (
    <section id="services" data-testid="services-section" className="bg-[#0A1128] py-24 md:py-32 relative overflow-hidden">
      <div className="absolute inset-0 grain opacity-50" />
      <div className="relative max-w-[1400px] mx-auto px-6 md:px-12 lg:px-16">
        <div className="max-w-2xl">
          <div className="eyebrow text-[#C5A059]">{t.services.eyebrow}</div>
          <h2 className="heading-display mt-5 text-white text-3xl sm:text-4xl lg:text-5xl">{t.services.title}</h2>
        </div>

        <div className="grid lg:grid-cols-12 gap-6 mt-16">
          {/* Baugewerbe – feature card */}
          <article data-testid="service-construction" className="lg:col-span-7 relative overflow-hidden border border-white/10 hover:border-[#C5A059]/60 transition-colors min-h-[460px] group">
            <div
              className="absolute inset-0 bg-cover bg-center opacity-50 group-hover:opacity-70 transition-opacity duration-700"
              style={{ backgroundImage: `url(${CONSTRUCTION_IMG})` }}
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#0A1128] via-[#0A1128]/70 to-transparent" />
            <div className="relative p-10 lg:p-12 h-full flex flex-col justify-end">
              <div className="eyebrow text-[#C5A059]">{t.services.construction.subtitle}</div>
              <h3 className="font-display text-white text-3xl lg:text-4xl mt-3">{t.services.construction.title}</h3>
              <ul className="mt-8 space-y-3">
                {t.services.construction.items.map((it, i) => (
                  <li key={i} className="flex items-start gap-3 text-white/85">
                    <Check size={16} weight="bold" className="text-[#C5A059] mt-1 shrink-0" />
                    <span className="text-[15px]">{it}</span>
                  </li>
                ))}
              </ul>
            </div>
          </article>

          {/* Weitere Branchen */}
          <article data-testid="service-other" className="lg:col-span-5 relative overflow-hidden border border-white/10 hover:border-[#C5A059]/60 transition-colors min-h-[460px] group">
            <div
              className="absolute inset-0 bg-cover bg-center opacity-30 group-hover:opacity-50 transition-opacity duration-700"
              style={{ backgroundImage: `url(${OTHER_IMG})` }}
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#12161F] via-[#12161F]/85 to-[#12161F]/50" />
            <div className="relative p-10 lg:p-12 h-full flex flex-col justify-end">
              <div className="eyebrow text-[#C5A059]">{t.services.other.subtitle}</div>
              <h3 className="font-display text-white text-3xl lg:text-4xl mt-3">{t.services.other.title}</h3>
              <ul className="mt-8 grid grid-cols-1 gap-2.5">
                {t.services.other.items.map((it, i) => (
                  <li key={i} className="flex items-start gap-3 text-white/85">
                    <Check size={16} weight="bold" className="text-[#C5A059] mt-1 shrink-0" />
                    <span className="text-[15px]">{it}</span>
                  </li>
                ))}
              </ul>
            </div>
          </article>
        </div>
      </div>
    </section>
  );
}
